export default "__VITE_ASSET__DHJnXGCv__"